import {
  ChevronLeft,
  ChevronRight,
  Wallet,
  PlusCircle,
  MinusCircle,
  ShoppingCart,
  ArrowRightLeft,
  Banknote,
  Receipt,
  Undo,
  Gift,
  Send,
} from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const TransactionItem = ({ transaction, onDownloadReceipt }) => {
  const amountString =
    typeof transaction.amount === "number"
      ? transaction.type === "credit"
        ? `+₹${transaction.amount.toLocaleString()}`
        : `-₹${Math.abs(transaction.amount).toLocaleString()}`
      : transaction.amount;

  const getTransactionIcon = () => {
    const note = transaction.note?.toLowerCase() || '';
    
    if (transaction.type === "credit") {
      if (note.includes("deposit")) return <Banknote className="h-5 w-5 text-green-500" />;
      if (note.includes("refund")) return <Undo className="h-5 w-5 text-green-500" />;
      if (note.includes("reward")) return <Gift className="h-5 w-5 text-green-500" />;
      return <PlusCircle className="h-5 w-5 text-green-500" />;
    } else {
      if (note.includes("shopping")) return <ShoppingCart className="h-5 w-5 text-red-500" />;
      if (note.includes("bill")) return <Receipt className="h-5 w-5 text-red-500" />;
      if (note.includes("transfer")) return <Send className="h-5 w-5 text-red-500" />;
      return <MinusCircle className="h-5 w-5 text-red-500" />;
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm flex items-center hover:bg-gray-50 transition border border-gray-100">
      <div className="bg-gray-50 p-3 rounded-full mr-4">
        {getTransactionIcon()}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-medium text-gray-800 truncate capitalize">
          {transaction.note}
        </h3>
        <p className="text-xs text-gray-500 mt-1">
          {new Date(transaction.createdAt || transaction.time).toLocaleString()}
        </p>
      </div>
      <div className="flex items-center gap-4">
        <span
          className={`font-medium text-sm whitespace-nowrap ${
            transaction.type === "credit" ? "text-green-600" : "text-red-600"
          }`}
        >
          {amountString}
        </span>
        <div className="flex items-center gap-1.5">
          {onDownloadReceipt && transaction.type === "credit" && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDownloadReceipt(transaction);
              }}
              className="px-3 py-1.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 text-xs font-bold rounded transition whitespace-nowrap"
            >
              Download Receipt
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export const TransactionList = ({
  transactions,
  currentPage,
  totalPages,
  onPageChange,
  onDownloadReceipt,
}) => (
  <div className="space-y-3">
    {transactions.length === 0 ? (
      <div className="bg-white p-6 rounded-lg shadow-sm text-center text-gray-500 border border-gray-100">
        No transactions found
      </div>
    ) : (
      <>
        <div className="space-y-2">
          {transactions.map((transaction) => (
            <TransactionItem 
              key={transaction.id || transaction._id || Math.random()} 
              transaction={transaction} 
              onDownloadReceipt={onDownloadReceipt}
            />
          ))}
        </div>

        {totalPages > 1 && (
          <div className="flex justify-between items-center mt-6 bg-white p-3 rounded-lg border border-gray-100">
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`flex items-center px-4 py-2 rounded-md text-sm ${
                currentPage === 1
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-indigo-600 hover:bg-indigo-50"
              }`}
            >
              <ChevronLeft className="h-4 w-4 mr-2" />
              Previous
            </button>

            <span className="text-sm text-gray-600">
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`flex items-center px-4 py-2 rounded-md text-sm ${
                currentPage === totalPages
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-indigo-600 hover:bg-indigo-50"
              }`}
            >
              Next
              <ChevronRight className="h-4 w-4 ml-2" />
            </button>
          </div>
        )}
      </>
    )}
  </div>
);